import { TranslatePipe } from '@ngx-translate/core';
import { isSubitemActive } from '../../../shared/helpers/menu-subitem-active';
import { router } from '../../../shared/shared.global-service';
import { LayoutService } from '../../services/layout.service';
import { Pipe } from '@angular/core';

// Hotfix to reduce recomputing of calling a function endlessly
@Pipe({
    name: 'menuPipe',
})
export class MenuPipe extends TranslatePipe {

    public override transform(item: any, layoutService: LayoutService): any {
        return (
            router.url !== '/' &&
            !layoutService.isStatic() &&
            !layoutService.isOverlay() &&
            (router.url.includes(item.routerLink) ||
                (!!item.items?.length &&
                    isSubitemActive(item.items, router.url)))
        );
    }

}
